export const types = {
  // Async
  UPLOAD_CONTENT_ASYNC: "UPLOAD_CONTENT_ASYNC",
  UPLOAD_PRODUCT_ASYNC: "UPLOAD_PRODUCT_ASYNC",
  EDIT_SWAP_PRODUCT_ASYNC: "EDIT_SWAP_PRODUCT_ASYNC",
  EDIT_SELL_RENT_PRODUCT_ASYNC: "EDIT_SELL_RENT_PRODUCT_ASYNC",
  UPLOAD_SELL_PRODUCT_ASYNC: "UPLOAD_SELL_PRODUCT_ASYNC",
  UPLOAD_SWAP_PRODUCT_ASYNC: "UPLOAD_SWAP_PRODUCT_ASYNC",
  UPLOAD_RENT_PRODUCT_ASYNC: "UPLOAD_RENT_PRODUCT_ASYNC",
  ADD_PRODUCT_MEMORY: "ADD_PRODUCT_MEMORY",
  CREATE_VOUCHER: "CREATE_VOUCHER",
  DEACTIVATE_VOUCHER: "DEACTIVATE_VOUCHER",
  REACTIVATE_VOUCHER: "REACTIVATE_VOUCHER",
  UPLOAD_PASSON_PRODUCT: "UPLOAD_PASSON_PRODUCT",
  EDIT_VOUCHER: "EDIT_VOUCHER",

  // Sync
  UPLOAD_CONTENT_SUCCESS: "UPLOAD_CONTENT_SUCCESS",
  UPLOAD_CONTENT_FAILED: "UPLOAD_CONTENT_FAILED",
  UPLOAD_PRODUCT_SUCCESS: "UPLOAD_PRODUCT_SUCCESS",
  UPLOAD_PRODUCT_FAILED: "UPLOAD_PRODUCT_FAILED",
  SET_PRODUCT_MEMORY: "SET_PRODUCT_MEMORY",
  ADD_CREATED_VOUCHER: "ADD_CREATED_VOUCHER",
  REMOVE_ACTIVE_VOUCHER: "REMOVE_ACTIVE_VOUCHER",
  MAKE_VOUCHER_ACTIVE: "MAKE_VOUCHER_ACTIVE",
  SET_EDITED_VOUCHER: "SET_EDITED_VOUCHER",
  REMOVE_PASSEDON_PRODUCT: "REMOVE_PASSEDON_PRODUCT",
};
